import React from 'react';

export default class Modal extends React.Component {
    render () {
        return (
            <div id="hi-form-modal" onClick={this.props.close}>
                <div className="hi-form">
                    <div id="hi-close-form" onClick={this.props.close}>X</div>
                    <h3>Confira seu NPS!</h3>
                    <iframe
                    title="hi-modal-form"
                    src="https://conteudo.hiplatform.com/l/648343/2020-05-12/2hk7hj"
                    width="100%"
                    height="500"
                    type="text/html"
                    frameBorder="0"
                    allowtransparency="true">
                    </iframe>
                </div>
            </div>
        );
    }
}